module.exports = __webpack_public_path__ + "img/point-agile-1.5f5e7e40.png";